import { Injectable } from '@angular/core';
import {SessionService} from './session.service';
import {LocalStorageService} from './local-storage.service';
import {AngularFirestore} from '@angular/fire/firestore';
import {COLLECTION_NAME} from '../../shared/constants';
import firebase from 'firebase';
import {CommonService} from './common.service';
import {Keisha} from '../../shared/interfaces/keisha';
import {ShukkaSaki} from '../../shared/interfaces/shukkasaki';
import {Keishu} from '../../shared/interfaces/keishu';
import {Farm} from '../../shared/interfaces/farm';
import {SaizaiSaiketsuNichireiMaster} from '../../shared/interfaces/saizai-saiketsu-nichirei-master';
import {VaccineMaster} from '../../shared/interfaces/vaccine';
import {FeedMaster} from '../../shared/interfaces/feed';
import {TentouMaster} from '../../shared/interfaces/tentou';
import {VaccineProgramMaster} from '../../shared/interfaces/vaccine-program';
import {MokuhyouTemperature} from "../../shared/interfaces/mokuhyou-tempreture";
import {take} from 'rxjs/operators';

interface KoushinKaisuuSum {
  masterName: string;
  sum: number;
}

@Injectable({
  providedIn: 'root'
})
export class MasterService {
  public farmMaster: Farm[] = [];
  public keishaMaster: Keisha[] = [];
  public shukkaSakiMaster: ShukkaSaki[] = [];
  public keishuMaster: Keishu[] = [];
  public vaccineMaster: VaccineMaster[] = [];
  public vaccineProgramMaster: VaccineProgramMaster[] = [];
  public saizaiSaiketsuNichireiMaster: SaizaiSaiketsuNichireiMaster[] = [];
  public feedMaster: FeedMaster[] = [];
  public tentouMaster: TentouMaster[] = [];
  public shiboukeiReportMaster: any[] = [];
  public mokuhyouTemperatureMaster: MokuhyouTemperature[] = [];
  private forceUpdate = false;

  constructor(private localStorageService: LocalStorageService,
              private sessionService: SessionService,
              public commonService: CommonService,
              private db: AngularFirestore) {
  }

  /**
   *
   */
  checkMasters() {
    const currentSum = this.localStorageService.get<KoushinKaisuuSum[]>('koushinKaisuuSum') ?? [];
    const sumMap = new Map(currentSum.map((obj) => [obj.masterName, obj.sum]));
    if (!this.sessionService.session.personalSetting) { return; }
    const domain = this.sessionService.session.personalSetting.customerId;
    this.db.collection(COLLECTION_NAME.CUSTOMERS).doc(domain)
      .collection('masters').doc('koushinKaisuuSum').snapshotChanges()
      .subscribe(doc => {
        // 「koushinKaisuuSum」が未定義（初めてそのcustomerIdでログイン）の場合、
        //  koushinKaisuuSum docを作成
        if (!doc.payload.exists) {
          doc.payload.ref.set({'map': {}});
          return;
        }
        const sums = doc.payload.data();
        if (!sums) { return; }
        const sumsArray: any = [];
        Object.keys(sums.map).forEach(key => {
          sumsArray.push({masterName: key, sum :sums.map[key]});
        });
        const newSumString = JSON.stringify(sumsArray);
        localStorage.setItem('koushinKaisuuSum', newSumString);
        sumsArray.forEach((master: any) => {
          const oldSum = sumMap.get(master.masterName);
          if (!oldSum || master.sum > oldSum) {
            this.getMaster(master.masterName)
              .then(() => console.log('succsess to get: ', master.masterName))
              .catch(() => console.log('error to get: ', master.masterName));
          }
        });
      });
  }

  /**
   * 指定されたMasterのデータをFirestoreから取得し、
   * masterService内の変数及びlocalStorageにセット
   * @param masterName
   */
  private getMaster(masterName: string) {
    return new Promise<void>(resolve => {
      const list: firebase.firestore.DocumentData[] = [];
      // get()を使用した場合
      this.db.collection(COLLECTION_NAME.CUSTOMERS).doc(this.sessionService.session.personalSetting.customerId).collection(masterName).get().pipe(take(1)).subscribe(querySnapshot => {
      // this.db.collection(COLLECTION_NAME.CUSTOMERS).doc(this.sessionService.session.personalSetting.customerId).collection(masterName).valueChanges({idField: 'id'}).subscribe(querySnapshot => {
        querySnapshot.forEach(doc => {
          // get()を使用した場合
          const tempDoc = doc.data();
          tempDoc.id = doc.id;
          list.push(tempDoc);
          // list.push(doc);
        });
        switch (masterName) {
          case COLLECTION_NAME.FARMMASTER:
            this.farmMaster = list as Farm[];
            break;
          case COLLECTION_NAME.KEISHAMASTER:
            list.map(meisai => {meisai.farmKeisha = meisai.farmName + ' ' + meisai.name;});
            this.commonService.sortObjectArray(list, 'farmKeisha');
            this.keishaMaster = list as Keisha[];
            break;
          case COLLECTION_NAME.KEISHUMASTER:
            this.keishuMaster = list as Keishu[];
            break;
          case COLLECTION_NAME.SHUKKASAKIMASTER:
            this.commonService.sortObjectArray(list, 'name');
            this.shukkaSakiMaster = list as ShukkaSaki[];
            break;
          case COLLECTION_NAME.VACCINEMASTER:
            if (list[0]) {
              this.commonService.sortObjectArray(list[0].vaccines, 'vaccineName');
            }
            this.vaccineMaster = list as VaccineMaster[];
            break;
          case COLLECTION_NAME.VACCINEPROGRAMMASTER:
            this.vaccineProgramMaster = list as VaccineProgramMaster[];
            break;
          case COLLECTION_NAME.SAIZAISAIKETSUNICHIREIMASTER:
            this.saizaiSaiketsuNichireiMaster = list as SaizaiSaiketsuNichireiMaster[];
            break;
          case COLLECTION_NAME.FEEDMASTER:
            this.feedMaster = list as FeedMaster[];
            break;
          case COLLECTION_NAME.TENTOUMASTER:
            this.tentouMaster = list as TentouMaster[];
            break;
          case COLLECTION_NAME.SHIBOUKEIREPORTMASTER:
            this.shiboukeiReportMaster = list;
            break;
          case COLLECTION_NAME.MOKUHYOUTEMPERATUREMASTER:
            this.mokuhyouTemperatureMaster = list as MokuhyouTemperature[];
            break;
          default:
            break;
        }
        this.localStorageService.set(masterName, list);
        return resolve();
      });
    });
  }

  /**
   * 各マスタが取得されていなければ取得。
   */
  getMasters() {
    return new Promise<void>((resolve, reject) => {
      if (!this.sessionService.session.personalSetting) { return reject('unauthorised'); }
      let i = 11;
      const tempFarms = this.localStorageService.get<Farm[]>(COLLECTION_NAME.FARMMASTER);
      this.farmMaster = tempFarms ? tempFarms : [];
      if (this.forceUpdate || !this.farmMaster.length) {
        this.getMaster(COLLECTION_NAME.FARMMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }

      const tempKeishas = this.localStorageService.get<Keisha[]>(COLLECTION_NAME.KEISHAMASTER);
      this.keishaMaster = tempKeishas ? tempKeishas : [];
      if (this.forceUpdate || !this.keishaMaster.length) {
        this.getMaster(COLLECTION_NAME.KEISHAMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }

      const tempKeishus = this.localStorageService.get<Keishu[]>(COLLECTION_NAME.KEISHUMASTER);
      this.keishuMaster = tempKeishus ? tempKeishus : [];
      if (this.forceUpdate || !this.keishuMaster.length) {
        this.getMaster(COLLECTION_NAME.KEISHUMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }

      const tempShukkaSakis = this.localStorageService.get<ShukkaSaki[]>(COLLECTION_NAME.SHUKKASAKIMASTER);
      this.shukkaSakiMaster = tempShukkaSakis ? tempShukkaSakis : [];
      if (this.forceUpdate || !this.shukkaSakiMaster.length) {
        this.getMaster(COLLECTION_NAME.SHUKKASAKIMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }

      const tempVaccineMaster = this.localStorageService.get<VaccineMaster[]>(COLLECTION_NAME.VACCINEMASTER);
      this.vaccineMaster = tempVaccineMaster ? tempVaccineMaster : [];
      if (this.forceUpdate || !this.vaccineMaster.length) {
        this.getMaster(COLLECTION_NAME.VACCINEMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }

      const tempVaccineProgramMaster = this.localStorageService.get<VaccineProgramMaster[]>(COLLECTION_NAME.VACCINEPROGRAMMASTER);
      this.vaccineProgramMaster = tempVaccineProgramMaster ? tempVaccineProgramMaster : [];
      if (this.forceUpdate || !this.vaccineProgramMaster.length) {
        this.getMaster(COLLECTION_NAME.VACCINEPROGRAMMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }

      const tempSaizaiSaiketsu = this.localStorageService.get<SaizaiSaiketsuNichireiMaster[]>(COLLECTION_NAME.SAIZAISAIKETSUNICHIREIMASTER);
      this.saizaiSaiketsuNichireiMaster = tempSaizaiSaiketsu ? tempSaizaiSaiketsu : [];
      if (this.forceUpdate || !this.saizaiSaiketsuNichireiMaster.length) {
        this.getMaster(COLLECTION_NAME.SAIZAISAIKETSUNICHIREIMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }

      const tempFeedMaster = this.localStorageService.get<FeedMaster[]>(COLLECTION_NAME.FEEDMASTER);
      this.feedMaster = tempFeedMaster ? tempFeedMaster : [];
      if (this.forceUpdate || !this.feedMaster.length) {
        this.getMaster(COLLECTION_NAME.FEEDMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }

      const tempTentou = this.localStorageService.get<TentouMaster[]>(COLLECTION_NAME.TENTOUMASTER);
      this.tentouMaster = tempTentou ? tempTentou : [];
      if (this.forceUpdate || !this.tentouMaster.length) {
        this.getMaster(COLLECTION_NAME.TENTOUMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }

      const tempShiboukeiReport = this.localStorageService.get<any>(COLLECTION_NAME.SHIBOUKEIREPORTMASTER);
      this.shiboukeiReportMaster = tempShiboukeiReport ? tempShiboukeiReport : [];
      if (this.forceUpdate || !this.shiboukeiReportMaster.length) {
        this.getMaster(COLLECTION_NAME.SHIBOUKEIREPORTMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }

      const tempMokuhyouTempreture = this.localStorageService.get<MokuhyouTemperature[]>(COLLECTION_NAME.MOKUHYOUTEMPERATUREMASTER);
      this.mokuhyouTemperatureMaster = tempMokuhyouTempreture ? tempMokuhyouTempreture : [];
      if (this.forceUpdate || !this.shiboukeiReportMaster.length) {
        this.getMaster(COLLECTION_NAME.MOKUHYOUTEMPERATUREMASTER).then(() => {
          i--;
          if (i === 0) {
            resolve();
          }
        });
      } else {
        i--;
        if (i === 0) {
          resolve();
        }
      }
    });
  }
}
